import { EAreaType } from ".";

export interface IPosition {
  id: string;
  name: string;
  type: EAreaType;
}
export enum ESearchPopupType {
  area = "area",
  trainLine = "trainLine",
}

const GetMultiSearchURL = function (
  type: string | undefined,
  codes: string,
  pid?: string
) {
  switch (type) {
    case EAreaType.city:
      return `?type=City&codes=${codes}`;
    case EAreaType.line:
      return `?type=Trainline&prefectureCode=${pid}&codes=${codes}`;
    case EAreaType.station:
      return `?type=Trainstation&codes=${codes}`;
    default:
      return "";
  }
};

export interface ISelectItem {
  code: string;
  url: string;
  count: string;
  resourceType?: string;
}
class PopupHelper {
  private selected: Map<string, ISelectItem>;
  private positionArray: IPosition[];
  public type: ESearchPopupType;

  constructor() {
    this.selected = new Map();
    this.positionArray = [];
    this.type = ESearchPopupType.area;
  }

  updateSelected(id: string, value: ISelectItem) {
    if (this.selected.has(id)) {
      this.selected.delete(id);
    } else {
      this.selected.set(id, value);
    }
  }

  getCurrent() {
    return this.positionArray.at(-1);
  }

  getSearchUrl() {
    /* 
    Attention: only return the path after '/en/rent'

    area
    1 item /en/rent/kinki/shiga/kusatsu-shi-252069
    1+ item /en/rent/?type=City&codes=112011+112101

    trainLine
    1 item(node) /en/rent/region/prefecture/line
    1+ item(all node) /en/rent/?type=Trainline&prefectureCode=17&codes=99426+11419

    1 item(leaf) /en/rent/region/prefecture/station
    1+ item(all leaf) /en/rent/?type=Trainstation&codes=1132617+1132614+1132615
    */
    let url = "";
    if (this.selected.size === 1) {
      return this.selected.values().next().value?.url;
    } else {
      const currentPosition = this.getCurrent();
      if (!currentPosition) return;
      let pid;
      if (currentPosition.type === EAreaType.line) {
        pid = currentPosition.id;
      }

      const keys = this.selected.keys();
      let codes = keys.next().value;
      for (const code of keys) {
        codes = codes + "+" + code;
      }

      url = GetMultiSearchURL(currentPosition.type, codes as string, pid);
      return url;
    }
  }

  clearSelected() {
    this.selected.clear();
  }

  getSelected() {
    return this.selected;
  }

  getPositionArray() {
    return this.positionArray;
  }

  positionGo(target: IPosition) {
    let changed = false;
    const oldIndex = this.positionArray.findIndex(
      (item) => item.id === target.id && item.name === target.name
    );
    if (oldIndex === -1) {
      this.positionArray.push(target);
      return true;
    }
    while (this.positionArray.length - 1 > oldIndex) {
      this.positionArray.pop();
      changed = true;
    }
    return changed;
  }
}

const popupHelper = new PopupHelper();
export default popupHelper;
